module.exports = __webpack_public_path__ + "img/fb.f047a6c6.svg";